// src/pages/PeopleCareerPage.js
import React from 'react';
import './PeopleCareerPage.css';
import alessioImage from '../assets/images/alessio.png';
import heroBackground from '../assets/images/home-hero2.png';
import brandingLogo from '../assets/images/branding-vanguard3.png';
import whiteV from '../assets/images/white-v.png'; // 

const PeopleCareerPage = () => {
  const expertiseAreas = [
    'Painting and surface care',
    'Gardening and landscape maintenance',
    'General maintenance and repairs',
    'Commercial and residential cleaning',
    'Preventative maintenance and inspections',
    'Safety and compliance support'
  ];

  return (
    <div className="people-page">
      {/* Hero Section with Background Image */}
      <section className="people-hero">
        <div className="hero-background">
          {/*<img src={heroBackground} alt="Background" className="hero-bg-image" />*/}
          <div className="hero-overlay"></div>
          <div className="hero-content-wrapper">
            <div className="container">
              <div className="hero-two-columns">
                {/* Left column - Alessio Image */}
                <div className="hero-left">
                  <img src={alessioImage} alt="Alessio Bonserio, CEO" className="alessio-image" />
                </div>
                
                {/* Right column - Quote */}
                <div className="hero-right">
                  <div className="quote-container">
                    <p className="quote-text">
                      "Vanguard is built on the strength, integrity, and
                      dedication of our people. Their commitment to
                      excellence is what defines our standards and
                      drives the value we deliver every day."
                    </p>
                    <p className="quote-author">— Alessio Bonserio, CEO</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Our People Section - Blue Background */}
      <section className="people-about">
        <div className="container">
          <div className="about-wrapper">
            {/* Top text */}
            <div className="about-top">
              <p className="about-paragraph">
                At Vanguard, our people are the foundation of everything we do. We are committed<br />
                to building a team of professionals who take pride in their work, operate with integrity,<br />
                and share our dedication to quality, safety, and excellence.<br /><br />
                We foster an environment where individuals are respected, supported, and empowered<br />
                to grow. Whether on-site or behind the scenes, every member of our team plays a vital<br />
                role in enhancing asset value and ensuring the highest standards of care.
              </p>
            </div>
            
            {/* Bottom - Two columns with space-between */}
            <div className="about-bottom">
              <div className="about-bottom-left">
                <p className="joining-text">
                  Joining Vanguard means becoming part<br />
                  of a company that values professionalism,<br />
                  accountability, and long-term career<br />
                  development.
                </p>
              </div>
              <div className="about-bottom-right">
                <img src={brandingLogo} alt="Vanguard" className="branding-logo" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Professionals Section */}
      <section className="people-professionals">
        <div className="container">
          <div className="professionals-two-columns">
            {/* Left column */}
            <div className="professionals-left">
              <h2 className="section-title">Our Professionals</h2>
              <p className="professionals-text">
                Vanguard brings together a diverse team of<br />
                experienced professionals across all areas of<br />
                facilities services.<br /><br />
                Each specialist contributes to maintaining,<br />
                protecting, and enhancing the environments<br />
                we manage.
              </p>
            </div>
            
            {/* Right column */}
            <div className="professionals-right">
              <p className="expertise-label">Our expertise includes:</p>
              <ul className="expertise-list">
                {expertiseAreas.map((area, index) => (
                  <li key={index} className="expertise-item">
                    <span className="dot-icon">•</span>
                    <span>{area}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Divider Line */}
      <div className="section-divider">
        <div className="container">
          <div className="divider-line"></div>
        </div>
      </div>

      {/* Enquire Section */}
      <section className="people-enquire">
        <div className="container">
          <div className="enquire-two-columns">
            {/* Left column */}
            <div className="enquire-left">
              <h2 className="section-title">Enquire — Work With Us</h2>
              <p className="enquire-text">
                Vanguard is always open to connecting with skilled,<br />
                reliable, and motivated professionals who share our<br />
                standards and values.<br /><br />
                If you are interested in becoming part of our team,<br />
                we invite you to submit an enquiry. We welcome<br />
                expressions of interest from individuals across all<br />
                areas of facilities services and operational support.
              </p>
            </div>
            
            {/* Right column */}
            <div className="enquire-right">
              <div className="email-container">
                <p className="email-label">Enquiries can be submitted via our email:</p>
                <a href="mailto:contact@vanguard.fsg.com.au" className="email-address">
                  contact@vanguard.fsg.com.au
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PeopleCareerPage;